/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useMemo, useState } from "react";
import MondaySlot from "./Slots/MondaySlot";
import { URLS } from "../../../Services/Constant";
import { post } from "../../../Services/ApiHandler";
import { daysList } from "../../StaticData";
import PrefilledSlots from "./Slots/PrefilledSlots";

const Slot = ({
  viewOnly,
  property_id,
  room_id,
  tabsData,
  setTabsData,
  prefillSlots,
}) => {
  const [selectedTab, setSelectedTab] = useState("Monday");
  const [slotData, setSlotData] = useState({});

  useEffect(() => {
    viewPrices();
  }, [selectedTab, room_id]);

  const viewPrices = async () => {
    if (!room_id) return;
    const payload = {
      property_id: property_id,
      property_room_id: room_id,
      day: selectedTab,
    };
    const res = await post(`${URLS.PROPERTY_SLOT_SPECIAL_DATES}`, payload);
    if (res?.status === "success") {
      const {
        special_dates,
        days,
        day_prices,
        created_slots,
        not_created_slots,
      } = res?.data;
      setTabsData?.({ slot: days, specialDates: special_dates });
      let created = "";
      let not_created = "";

      let blocked_slots = created_slots?.map((item) => {
        let val = `${item?.timeslot_name}(${item?.timeslot_type?.substring(
          0,
          1,
        )})`.replaceAll(" ", "");
        created = `${created} ${"\u00A0"} ${val}`;
        return { value: item?.id, label: item?.timeslot_name, ...item };
      });

      let available_slots = not_created_slots?.map((item) => {
        let val = `${item?.timeslot_name?.replace(
          " ",
          "",
        )}(${item?.timeslot_type?.substring(0, 1)}) `;
        not_created = `${not_created} ${"\u00A0"} ${val}`;
        return { value: item?.id, label: item?.timeslot_name, ...item };
      });

      setSlotData((prev) => ({
        ...prev,
        [selectedTab]: {
          createdSlots: created,
          balanceSlots: not_created,
          slotsList: day_prices,
          currentSlot: selectedTab,
          availableSlots: available_slots,
          blocked_slots: blocked_slots,
        },
      }));
    }
  };

  // Prefilled rows that are NOT yet created for the selected day.
  // Memoised so PrefilledSlots doesn't get a new array on every render.
  const dayData = slotData?.[selectedTab];
  const pendingPrefill = useMemo(() => {
    if (!prefillSlots?.length || !dayData) return [];
    const createdIds = new Set(
      (dayData.blocked_slots ?? []).map((s) => String(s?.id)),
    );
    return prefillSlots.filter((s) => !createdIds.has(String(s?.time_slot_id)));
  }, [prefillSlots, dayData]);

  return (
    <div className="mt-4 bg-sec1 px-3 py-4 rounded-4">
      <p className="f4 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 pointer">
        {" "}
        Slots
      </p>
      <div>
        <div className="d-flex ac-js gap-3 mt-2">
          {daysList.map((day, index) => (
            <p
              key={day}
              onClick={() => setSelectedTab(day)}
              className={`${
                selectedTab === day ? "prim-btn" : "slot-act-btn"
              } f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ${
                index !== 0 ? "ms-1" : ""
              } pointer`}
            >
              {" "}
              {`${day}  (${tabsData?.slot?.[day] ?? 0})`}
            </p>
          ))}
        </div>

        {/* Created slots: same view as the normal add/edit flow */}
        <MondaySlot
          viewOnly={viewOnly}
          slotData={dayData}
          property_id={property_id}
          room_id={room_id}
          viewPrices={viewPrices}
        />

        {/* Prefilled slots still waiting to be created */}
        {pendingPrefill.length > 0 && (
          <div className="mt-4">
            {/* <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
              Pending slots
            </p> */}
            <PrefilledSlots
              key={selectedTab}
              timeSlots={pendingPrefill}
              availableSlots={dayData?.availableSlots}
              property_id={property_id}
              room_id={room_id}
              selectedDay={selectedTab}
              viewPrices={viewPrices}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Slot;
